module.exports = __webpack_public_path__ + "static/media/enrollment-default-logo.3c60cbee.png";